import type { ViewContainerRef } from '@angular/core';

import type { Observable } from 'rxjs';

import type { OnboardingVideo } from '@core/onboarding-lib-types';
import type { DialogRef } from '@core/user-interface-legacy';

export interface OnboardingVideoDialogOptions {
  ctaButtonLabel?: string;
}

export abstract class OnboardingVideosServiceBase {
  public abstract openVideoDialog(
    video: OnboardingVideo,
    vcRef: ViewContainerRef,
    markAsWatched: boolean,
    options?: OnboardingVideoDialogOptions,
  ): DialogRef;

  public abstract markAsWatched(video: Pick<OnboardingVideo, 'id'>): void;

  public abstract getVideo(videoId: string): Observable<OnboardingVideo>;
}
